import { useMemo } from "react";

const passwordRequirements = [
  {
    name: "containsNumber",
    test: pw => /\d+/.test(pw),
    description: "Contains at least 1 number"
  },
  {
    name: "containsSpecialCharacter",
    test: pw => /[~`!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/.test(pw),
    description: "Contains at least 1 special character"
  },
  {
    name: "containsUpperCaseLetter",
    test: pw => /[A-Z]/.test(pw),
    description: "Contains at least 1 uppercase letter"
  },
  {
    name: "containsLowerCaseLetter",
    test: pw => /[a-z]/.test(pw),
    description: "Contains at least 1 lowercase letter"
  },
  {
    name: "containsFourteenCharacters",
    test: pw => pw.length >= 14,
    description: "Contain at least 14 characters"
  }
];

function usePasswordFeedback(password) {
  return useMemo(
    () =>
      passwordRequirements.map(({ name, test, description }) => ({
        name,
        result: test(password),
        description
      })),
    [password]
  );
}
export default usePasswordFeedback;
